// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.registration-confirmation-print-root {
  --confirmation-primary: #4da7db;
  --confirmation-navy: #0b3350;
  --confirmation-muted: #8b9aa8;
  --confirmation-body: #4a5a69;
  --confirmation-border: #cfe3ea;
  --confirmation-surface: #f6f9fa;
  --confirmation-page: #eef3f6;
  width: 210mm;
  min-height: 297mm;
  box-sizing: border-box;
  padding: 7mm;
  position: relative;
  overflow: hidden;
  background: var(--confirmation-page);
  color: var(--confirmation-body);
  font-family: Arial, 'Segoe UI', 'DejaVu Sans', sans-serif;
  font-synthesis: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
}

.registration-confirmation-document,
.registration-confirmation-document * {
  box-sizing: border-box;
}

.registration-confirmation-document {
  width: 100%;
  min-height: 283mm;
  position: relative;
  overflow: hidden;
  border-radius: 5mm;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(11, 51, 80, 0.08);
  font-family: inherit;
}

/* Keep html2pdf below the exact A4 boundary to avoid a rounded blank page. */
.registration-confirmation-pdf-export {
  height: 296mm;
  min-height: 296mm;
}

.registration-confirmation-pdf-export
  .registration-confirmation-document {
  height: 282mm;
  min-height: 282mm;
}

.registration-confirmation-watermark {
  position: absolute;
  z-index: 0;
  width: 135mm;
  height: 135mm;
  object-fit: contain;
  top: 88mm;
  left: 30.5mm;
  opacity: 0.065;
  pointer-events: none;
}

.registration-confirmation-brand-header {
  position: relative;
  z-index: 1;
  display: flex;
  min-height: 43mm;
  align-items: center;
  gap: 5mm;
  padding: 7mm 9mm;
  background: var(--confirmation-primary);
}

.registration-confirmation-logo-shell {
  display: flex;
  width: 53mm;
  height: 27mm;
  flex: 0 0 53mm;
  align-items: center;
  justify-content: center;
  padding: 2mm 3mm;
  border-radius: 3mm;
  background: #ffffff;
}

.registration-confirmation-logo {
  display: block;
  width: 47mm;
  height: auto;
  max-width: 100%;
  max-height: 25mm;
  object-fit: contain;
}

.registration-confirmation-brand-copy {
  display: flex;
  min-width: 0;
  flex: 1 1;
  flex-direction: column;
  gap: 1.2mm;
  justify-content: center;
}

.registration-confirmation-brand-name {
  color: #ffffff;
  font-size: 15pt;
  font-weight: 700;
  letter-spacing: 2.2px;
  line-height: 1.1;
  text-transform: uppercase;
}

.registration-confirmation-brand-subtitle {
  color: #e6f5fc;
  font-size: 8.5pt;
}

.registration-confirmation-content {
  position: relative;
  z-index: 1;
  padding: 8mm 9mm 6mm;
}

.registration-confirmation-title-block {
  margin-bottom: 5mm;
}

.registration-confirmation-title {
  margin: 0;
  color: var(--confirmation-navy);
  font-size: 18pt;
  font-weight: 700;
  line-height: 1.25;
}

.registration-confirmation-description {
  max-width: 165mm;
  margin: 2mm 0 0;
  color: #66788a;
  font-size: 9.5pt;
  line-height: 1.6;
}

.registration-confirmation-eyebrow,
.registration-confirmation-support-eyebrow {
  display: block;
  color: var(--confirmation-muted);
  font-size: 8pt;
  font-weight: 700;
  letter-spacing: 1.1px;
  line-height: 1.3;
  text-transform: uppercase;
}

.registration-confirmation-customer-card {
  padding: 5mm 6mm;
  border-radius: 3mm;
  background: rgba(246, 249, 250, 0.56);
  page-break-inside: avoid;
  break-inside: avoid;
}

.registration-confirmation-customer-grid,
.registration-confirmation-service-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 8mm;
}

.registration-confirmation-customer-grid {
  margin-top: 2mm;
}

.registration-confirmation-field {
  min-width: 0;
  padding: 1.8mm 0;
}

.registration-confirmation-field-full {
  grid-column: 1 / -1;
  margin-top: 1mm;
  padding-top: 2.5mm;
  border-top: 0.25mm solid #e4ebef;
}

.registration-confirmation-field-label {
  display: block;
  margin-bottom: 0.8mm;
  color: var(--confirmation-muted);
  font-size: 8.5pt;
  line-height: 1.3;
}

.registration-confirmation-field strong {
  display: block;
  color: var(--confirmation-navy);
  font-size: 10.5pt;
  font-weight: 700;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.registration-confirmation-service-section,
.registration-confirmation-terms-section {
  margin-top: 6mm;
  page-break-inside: avoid;
  break-inside: avoid;
}

.registration-confirmation-service-card {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 1mm 38mm;
  margin-top: 2.5mm;
  overflow: hidden;
  border: 0.4mm solid var(--confirmation-border);
  border-radius: 3.5mm;
  background: rgba(255, 255, 255, 0.54);
  page-break-inside: avoid;
  break-inside: avoid;
}

.registration-confirmation-service-main {
  min-width: 0;
  padding: 5mm 5.5mm;
}

.registration-confirmation-service-main h2 {
  margin: 0 0 3.5mm;
  color: var(--confirmation-navy);
  font-size: 12pt;
  font-weight: 700;
  line-height: 1.35;
}

.registration-confirmation-service-grid {
  row-gap: 1.2mm;
}

.registration-confirmation-service-grid .registration-confirmation-field {
  padding: 1.3mm 0;
}

.registration-confirmation-service-grid .registration-confirmation-field strong {
  color: #28394a;
  font-size: 9.5pt;
}

.registration-confirmation-status-text {
  color: #0f9d6c !important;
}

.registration-confirmation-perforation {
  width: 1mm;
  background-image: linear-gradient(
    var(--confirmation-border) 60%,
    rgba(255, 255, 255, 0) 0%
  );
  background-position: top;
  background-repeat: repeat-y;
  background-size: 1mm 4mm;
}

.registration-confirmation-usage-stub {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: center;
  padding: 5mm 3mm;
  background: rgba(240, 248, 250, 0.58);
  text-align: center;
}

.registration-confirmation-usage-value {
  display: block;
  color: var(--confirmation-primary);
  font-size: 27pt;
  font-weight: 700;
  line-height: 1;
}

.registration-confirmation-usage-label {
  display: block;
  margin-top: 1.5mm;
  color: #4c7e92;
  font-size: 7.5pt;
  font-weight: 700;
  letter-spacing: 0.8px;
  line-height: 1.3;
  text-transform: uppercase;
}

.registration-confirmation-terms-list {
  counter-reset: registration-confirmation-terms;
  list-style: none;
  margin: 2mm 0 0;
  padding: 0;
  color: var(--confirmation-body);
  font-size: 9.5pt;
  line-height: 1.55;
}

.registration-confirmation-terms-list li {
  display: grid;
  grid-template-columns: 6mm minmax(0, 1fr);
  column-gap: 1.5mm;
  align-items: start;
  padding: 2mm 0 2mm 1mm;
  border-top: 0.25mm solid #f0f2f4;
}

.registration-confirmation-terms-list li:first-child {
  border-top: 0;
}

.registration-confirmation-terms-list li::before {
  counter-increment: registration-confirmation-terms;
  content: counter(registration-confirmation-terms);
  color: var(--confirmation-primary);
  font-weight: 700;
  line-height: 1.55;
  text-align: right;
}

.registration-confirmation-support-card {
  display: flex;
  flex-direction: column;
  gap: 1.2mm;
  margin-top: 6mm;
  padding: 4.5mm 5.5mm;
  border-radius: 3mm;
  background: var(--confirmation-navy);
  color: #ffffff;
  page-break-inside: avoid;
  break-inside: avoid;
}

.registration-confirmation-support-eyebrow {
  color: #bfe8f6;
}

.registration-confirmation-support-card strong {
  color: #ffffff;
  font-size: 10pt;
  line-height: 1.45;
}

.registration-confirmation-support-card > span:not(.registration-confirmation-support-eyebrow) {
  color: #c4dce7;
  font-size: 8.8pt;
  line-height: 1.45;
}

.registration-confirmation-print-root,
.registration-confirmation-print-root * {
  print-color-adjust: exact;
}

@page {
  size: A4 portrait;
  margin: 0;
}

@media print {
  body.registration-confirmation-printing * {
    visibility: hidden !important;
  }

  body.registration-confirmation-printing
    .registration-confirmation-print-root,
  body.registration-confirmation-printing
    .registration-confirmation-print-root * {
    visibility: visible !important;
  }

  body.registration-confirmation-printing .registration-confirmation-print-root {
    position: absolute;
    top: 0;
    left: 0;
    margin: 0;
    padding: 0;
    background: #ffffff;
  }

  body.registration-confirmation-printing .registration-confirmation-document {
    min-height: 297mm;
    border-radius: 0;
    box-shadow: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Registration/RegistrationConfirmationDocument.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,6BAA6B;EAC7B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,4BAA4B;EAC5B,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,+BAA+B;EAC/B,yDAAyD;EACzD,oBAAoB;EACpB,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;EAC5C,oBAAoB;AACtB;;AAEA,6EAA6E;AAC7E;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,SAAO;EACP,sBAAsB;EACtB,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,gCAAgC;EAChC,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,wBAAmB;EAAnB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,gDAAgD;EAChD,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;EAEE,eAAe;EACf,wBAAmB;EAAnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C,iBAAiB;EACjB,gBAAgB;EAChB,8CAA8C;EAC9C,oBAAoB;EACpB,qCAAqC;EACrC,wBAAmB;EAAnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV;;;GAGC;EACD,wBAAwB;EACxB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,8CAA8C;EAC9C,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kDAAkD;EAClD,iDAAiD;EACjD,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,wBAAmB;EAAnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE;IACE,6BAA6B;EAC/B;;EAEA;;;;IAIE,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,SAAS;IACT,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;EAClB;AACF","sourcesContent":[".registration-confirmation-print-root {\n  --confirmation-primary: #4da7db;\n  --confirmation-navy: #0b3350;\n  --confirmation-muted: #8b9aa8;\n  --confirmation-body: #4a5a69;\n  --confirmation-border: #cfe3ea;\n  --confirmation-surface: #f6f9fa;\n  --confirmation-page: #eef3f6;\n  width: 210mm;\n  min-height: 297mm;\n  box-sizing: border-box;\n  padding: 7mm;\n  position: relative;\n  overflow: hidden;\n  background: var(--confirmation-page);\n  color: var(--confirmation-body);\n  font-family: Arial, 'Segoe UI', 'DejaVu Sans', sans-serif;\n  font-synthesis: none;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n}\n\n.registration-confirmation-document,\n.registration-confirmation-document * {\n  box-sizing: border-box;\n}\n\n.registration-confirmation-document {\n  width: 100%;\n  min-height: 283mm;\n  position: relative;\n  overflow: hidden;\n  border-radius: 5mm;\n  background: #ffffff;\n  box-shadow: 0 1px 3px rgba(11, 51, 80, 0.08);\n  font-family: inherit;\n}\n\n/* Keep html2pdf below the exact A4 boundary to avoid a rounded blank page. */\n.registration-confirmation-pdf-export {\n  height: 296mm;\n  min-height: 296mm;\n}\n\n.registration-confirmation-pdf-export\n  .registration-confirmation-document {\n  height: 282mm;\n  min-height: 282mm;\n}\n\n.registration-confirmation-watermark {\n  position: absolute;\n  z-index: 0;\n  width: 135mm;\n  height: 135mm;\n  object-fit: contain;\n  top: 88mm;\n  left: 30.5mm;\n  opacity: 0.065;\n  pointer-events: none;\n}\n\n.registration-confirmation-brand-header {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  min-height: 43mm;\n  align-items: center;\n  gap: 5mm;\n  padding: 7mm 9mm;\n  background: var(--confirmation-primary);\n}\n\n.registration-confirmation-logo-shell {\n  display: flex;\n  width: 53mm;\n  height: 27mm;\n  flex: 0 0 53mm;\n  align-items: center;\n  justify-content: center;\n  padding: 2mm 3mm;\n  border-radius: 3mm;\n  background: #ffffff;\n}\n\n.registration-confirmation-logo {\n  display: block;\n  width: 47mm;\n  height: auto;\n  max-width: 100%;\n  max-height: 25mm;\n  object-fit: contain;\n}\n\n.registration-confirmation-brand-copy {\n  display: flex;\n  min-width: 0;\n  flex: 1;\n  flex-direction: column;\n  gap: 1.2mm;\n  justify-content: center;\n}\n\n.registration-confirmation-brand-name {\n  color: #ffffff;\n  font-size: 15pt;\n  font-weight: 700;\n  letter-spacing: 2.2px;\n  line-height: 1.1;\n  text-transform: uppercase;\n}\n\n.registration-confirmation-brand-subtitle {\n  color: #e6f5fc;\n  font-size: 8.5pt;\n}\n\n.registration-confirmation-content {\n  position: relative;\n  z-index: 1;\n  padding: 8mm 9mm 6mm;\n}\n\n.registration-confirmation-title-block {\n  margin-bottom: 5mm;\n}\n\n.registration-confirmation-title {\n  margin: 0;\n  color: var(--confirmation-navy);\n  font-size: 18pt;\n  font-weight: 700;\n  line-height: 1.25;\n}\n\n.registration-confirmation-description {\n  max-width: 165mm;\n  margin: 2mm 0 0;\n  color: #66788a;\n  font-size: 9.5pt;\n  line-height: 1.6;\n}\n\n.registration-confirmation-eyebrow,\n.registration-confirmation-support-eyebrow {\n  display: block;\n  color: var(--confirmation-muted);\n  font-size: 8pt;\n  font-weight: 700;\n  letter-spacing: 1.1px;\n  line-height: 1.3;\n  text-transform: uppercase;\n}\n\n.registration-confirmation-customer-card {\n  padding: 5mm 6mm;\n  border-radius: 3mm;\n  background: rgba(246, 249, 250, 0.56);\n  break-inside: avoid;\n}\n\n.registration-confirmation-customer-grid,\n.registration-confirmation-service-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  column-gap: 8mm;\n}\n\n.registration-confirmation-customer-grid {\n  margin-top: 2mm;\n}\n\n.registration-confirmation-field {\n  min-width: 0;\n  padding: 1.8mm 0;\n}\n\n.registration-confirmation-field-full {\n  grid-column: 1 / -1;\n  margin-top: 1mm;\n  padding-top: 2.5mm;\n  border-top: 0.25mm solid #e4ebef;\n}\n\n.registration-confirmation-field-label {\n  display: block;\n  margin-bottom: 0.8mm;\n  color: var(--confirmation-muted);\n  font-size: 8.5pt;\n  line-height: 1.3;\n}\n\n.registration-confirmation-field strong {\n  display: block;\n  color: var(--confirmation-navy);\n  font-size: 10.5pt;\n  font-weight: 700;\n  line-height: 1.35;\n  overflow-wrap: anywhere;\n}\n\n.registration-confirmation-service-section,\n.registration-confirmation-terms-section {\n  margin-top: 6mm;\n  break-inside: avoid;\n}\n\n.registration-confirmation-service-card {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 1mm 38mm;\n  margin-top: 2.5mm;\n  overflow: hidden;\n  border: 0.4mm solid var(--confirmation-border);\n  border-radius: 3.5mm;\n  background: rgba(255, 255, 255, 0.54);\n  break-inside: avoid;\n}\n\n.registration-confirmation-service-main {\n  min-width: 0;\n  padding: 5mm 5.5mm;\n}\n\n.registration-confirmation-service-main h2 {\n  margin: 0 0 3.5mm;\n  color: var(--confirmation-navy);\n  font-size: 12pt;\n  font-weight: 700;\n  line-height: 1.35;\n}\n\n.registration-confirmation-service-grid {\n  row-gap: 1.2mm;\n}\n\n.registration-confirmation-service-grid .registration-confirmation-field {\n  padding: 1.3mm 0;\n}\n\n.registration-confirmation-service-grid .registration-confirmation-field strong {\n  color: #28394a;\n  font-size: 9.5pt;\n}\n\n.registration-confirmation-status-text {\n  color: #0f9d6c !important;\n}\n\n.registration-confirmation-perforation {\n  width: 1mm;\n  background-image: linear-gradient(\n    var(--confirmation-border) 60%,\n    rgba(255, 255, 255, 0) 0%\n  );\n  background-position: top;\n  background-repeat: repeat-y;\n  background-size: 1mm 4mm;\n}\n\n.registration-confirmation-usage-stub {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  justify-content: center;\n  padding: 5mm 3mm;\n  background: rgba(240, 248, 250, 0.58);\n  text-align: center;\n}\n\n.registration-confirmation-usage-value {\n  display: block;\n  color: var(--confirmation-primary);\n  font-size: 27pt;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.registration-confirmation-usage-label {\n  display: block;\n  margin-top: 1.5mm;\n  color: #4c7e92;\n  font-size: 7.5pt;\n  font-weight: 700;\n  letter-spacing: 0.8px;\n  line-height: 1.3;\n  text-transform: uppercase;\n}\n\n.registration-confirmation-terms-list {\n  counter-reset: registration-confirmation-terms;\n  list-style: none;\n  margin: 2mm 0 0;\n  padding: 0;\n  color: var(--confirmation-body);\n  font-size: 9.5pt;\n  line-height: 1.55;\n}\n\n.registration-confirmation-terms-list li {\n  display: grid;\n  grid-template-columns: 6mm minmax(0, 1fr);\n  column-gap: 1.5mm;\n  align-items: start;\n  padding: 2mm 0 2mm 1mm;\n  border-top: 0.25mm solid #f0f2f4;\n}\n\n.registration-confirmation-terms-list li:first-child {\n  border-top: 0;\n}\n\n.registration-confirmation-terms-list li::before {\n  counter-increment: registration-confirmation-terms;\n  content: counter(registration-confirmation-terms);\n  color: var(--confirmation-primary);\n  font-weight: 700;\n  line-height: 1.55;\n  text-align: right;\n}\n\n.registration-confirmation-support-card {\n  display: flex;\n  flex-direction: column;\n  gap: 1.2mm;\n  margin-top: 6mm;\n  padding: 4.5mm 5.5mm;\n  border-radius: 3mm;\n  background: var(--confirmation-navy);\n  color: #ffffff;\n  break-inside: avoid;\n}\n\n.registration-confirmation-support-eyebrow {\n  color: #bfe8f6;\n}\n\n.registration-confirmation-support-card strong {\n  color: #ffffff;\n  font-size: 10pt;\n  line-height: 1.45;\n}\n\n.registration-confirmation-support-card > span:not(.registration-confirmation-support-eyebrow) {\n  color: #c4dce7;\n  font-size: 8.8pt;\n  line-height: 1.45;\n}\n\n.registration-confirmation-print-root,\n.registration-confirmation-print-root * {\n  -webkit-print-color-adjust: exact;\n  print-color-adjust: exact;\n}\n\n@page {\n  size: A4 portrait;\n  margin: 0;\n}\n\n@media print {\n  body.registration-confirmation-printing * {\n    visibility: hidden !important;\n  }\n\n  body.registration-confirmation-printing\n    .registration-confirmation-print-root,\n  body.registration-confirmation-printing\n    .registration-confirmation-print-root * {\n    visibility: visible !important;\n  }\n\n  body.registration-confirmation-printing .registration-confirmation-print-root {\n    position: absolute;\n    top: 0;\n    left: 0;\n    margin: 0;\n    padding: 0;\n    background: #ffffff;\n  }\n\n  body.registration-confirmation-printing .registration-confirmation-document {\n    min-height: 297mm;\n    border-radius: 0;\n    box-shadow: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
